import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  existPatient: {
    width: "100%",
    padding: '24px 24px 0px 24px',
  },

  headerContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },

  existPatientHeader1: {
    fontSize: '20px',
    fontFamily: 'Inter',
    color: '#1A2340',
    fontWeight: 600,
  },

  subText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    color: '#6B7280'
  },

  reasonForVisit: {
    width: '100%',
    height: '450px',
    borderRadius: '6px',
    border: '1px solid #D1D5DB',
    background: '#fff',
    boxSizing: 'border-box',
    fontFamily: 'Inter',
    fontSize: '16px',
    padding: '16px',
    resize: 'none',
    outline: 'none',

    '&::placeholder': {
      color: '#9CA3AF'
    },

    '@media (max-width: 768px)': {
      width: '100%',
      height: '300px',
    },
  },

  textareaContainer: {
    padding: '16px 24px 24px 24px'
  }
}))

const ReasonForVisitModal = ({ reasonForVisitText, setReasonForVisitText }) => {
  const classes = useStyles()
  return (
    <>
      <div>

        <div className={classes.existPatient}>
          <div className={classes.headerContainer}>
            <Typography className={classes.existPatientHeader1}>
              Reason for Visit
            </Typography>

            <Typography className={classes.subText}>
              Let us know why you're scheduling this appointment.
            </Typography>
          </div>
        </div>

        <div className={classes.textareaContainer}>
          <textarea
            placeholder="In a few words please describe your reason for this visit."
            className={classes.reasonForVisit}
            value={reasonForVisitText}
            onChange={(event) => setReasonForVisitText(event.target.value)}
          />
        </div>

      </div>
    </>
  )
}

export default ReasonForVisitModal